import React from 'react';
import { PageHeader } from '@/components/ui/page-header';

/** Même bande Repères pour tous les modules, sans deuxième système d'en-tête. */
export const PageHero = ({
  accroche, illustrationPlace, compact, ton, children, ...props
}) => (
  <PageHeader {...props} illustrationTestId="page-hero-illustration">
    {children ? <div className="pb-2">{children}</div> : null}
  </PageHeader>
);

export default PageHero;
